import {Component} from 'react';

import Auth from '../../lib/users/auth';
import AccessSection from "./access-section"
import Checkbox from '../checkbox';
import Dropdown from '../dropdowns/dropdown';
import validator from "validator";

import Input from '../../components/input-with-label';

import ApplicationSection from '../../views/grants-application/grants-application-section';
import axios from 'axios';

import CompaniesApi from '../../lib/companies/companies-api';

import CompanyTypes from '../company-types';

const filteredCompanyTypes = ['Limited Company', 'Sole Trader', 'Charity']

const companyTypes = {
    'Limited Company': {
        max: 8,
    },
    'Sole Trader': {
        max: 10,
    },
    'Charity': {
        max: 15,
    },
    'Partnership': null,
    'Non-for-profit': null,
    'CIC Social Enterprise': null,
}

export default class AccessPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            checkboxes: this.props.checkboxes,
            company: null,
            companyValues: {},
            industries: [],
            hasErrors: [],
            types: []
        }

        this.individualValidation = {
            'tel_no': (value) => validator.isMobilePhone(value),
            'email': (value) => validator.isEmail(value),
        }

        this.canBeEmpty = [
            'address_two'
        ]
    }

    componentDidMount() {
        this.props.setErrors(true);

        CompaniesApi.getIndustries().then(({data}) => {
            this.setState({industries: data}, () => {
                CompaniesApi.getCompany(Auth.user.company_id).then((data) => {
                    const profile = { ...data.company_profile.profile };

                    this.setState({company: data});

                    let errors = []

                    const types = this.fields();

                    this.setState({types});

                    types.forEach((type) => {
                        if (type.name == 'company_number' && profile.company_type !== null) {
                            if (filteredCompanyTypes.includes(profile.company_type)) {
                                if (type.value == null || type.value.length == 0) return errors.push(type);
                            }
                        } else {
                            if (type.value == null || type.value.length == 0) {
                                errors.push(type);
                            }
                        }
                    });

                    this.setState({ hasErrors: errors });

                    const hasErrors = (errors.length > 0);

                    this.props.setErrors(hasErrors);

                    this.props.setNextText(hasErrors ? 'Save and Proceed' : 'Proceed');

                    this.updateHasErrors();

                });
            })
        });

        this.props.setOnProceed(async () => {
            if(_.size(this.state.companyValues) >= 1) {
                await this.save();
                return true;
            }
               return true;
        });
    }

    componentWillUnmount() {
        this.props.setOnProceed(null);
    }

    async save() {
         await CompaniesApi.updateProfile(this.state.company.id, { profile: { ...this.state.company.company_profile.profile, ...this.state.companyValues }});
        let params = {};

        if(this.state.companyValues.hasOwnProperty('name')) {
            params['name'] = this.state.companyValues.name;
        }

        if(this.state.companyValues.hasOwnProperty('industry_name')) {
            params = {
                'company_industry_id' : this.state.company.company_industry_id,
                'name' : this.state.company.name
            };
        }


        if(_.size(params) >= 1) {
            return await CompaniesApi.update(this.state.company.id, params);
        }

        return;
    }

    fields() {
        const profile = {...this.state.company.company_profile.profile};
        const company = {...this.state.company};

        const industry = this.state.industries.find(i => i.id === this.state.company.company_industry_id);

        const types = [
            {
                type: 'Applicant Name',
                value: Auth.user.name,
            },
            {
                type: 'Role',
                value: Auth.user.roles[0].name,
            },
            {
                type: 'Number of employees',
                name: 'number_of_employees_range',
                value: profile.number_of_employees_range
            },
            {
                type: 'Company Email Address',
                name: 'email',
                value: profile.email,
            },
            {
                type: 'Telephone Number',
                name: 'tel_no',
                value: profile.tel_no
            },
            {
                type: 'Business Name',
                name: 'name',
                value: company.name
            },
            {
                type: 'Industry',
                name: 'industry_name',
                value: industry?.name
            },
            {
                type: 'Business Type',
                name: 'company_type',
                value: profile.company_type,
            },
            {
                type: 'Company Registration Number',
                name: 'company_number',
                value: profile.company_number
            },
            {
                type: 'Business Address Line 1',
                name: 'address_one',
                value: profile.address_one
            },
            {
                type: 'Business Address Line 2',
                name: 'address_two',
                value: profile.address_two
            },
            {
                type: 'Business Address City',
                name: 'address_city',
                value: profile.address_city
            },
            {
                type: 'Business Address Post Code',
                name: 'address_post_code',
                value: profile.address_post_code
            }
        ]


        return types;
    }

    onChange(e) {
        const {name, value} = e.target;

        this.setState({companyValues : Object.assign({}, this.state.companyValues, {
            [name] : value
            })}, () => {
            this.updateHasErrors();

        });

    }

    onChangeObject(e) {
        this.setState({companyValues : Object.assign({}, this.state.companyValues, e)}, () => {
            this.updateHasErrors();
        });
    }

    updateHasErrors() {
        // puts every profile key and value into an array and checks whether atleast one value is empty
        const profile = {...this.state.company.company_profile.profile};

        const type = this.getUpdatedValue('company_type') || profile.company_type;

        const hasErrors = this.state.hasErrors.filter( key => !this.canBeEmpty.includes(key.name));
        const companyValues = Object.fromEntries(Object.entries(this.state.companyValues).filter(([key]) => !this.canBeEmpty.includes(key)));

        let filteredKeys = Object.keys(companyValues).filter( key => {
            if (!filteredCompanyTypes.includes(type)) {
                return key !== 'company_number' && key !== 'company_number_type';
            }

            return true;
        });

        const atleastOneEmpty = filteredKeys.map(key => ({ key, value: companyValues[key] })).some(k => {
            if (k.key == 'company_number') {
                const { max } = companyTypes[type];

                return k.value.length !== max;
            }

            if (this.canBeEmpty.includes(k.key)) return false;

            return k.value.length == 0 || k.value == null
        });

        const hasIndividualValidationErrors = Object.keys(this.individualValidation).some(key => {
            return companyValues.hasOwnProperty(key) && !this.individualValidation[key](this.getUpdatedValue(key))
        })

        if (hasIndividualValidationErrors) {
            return this.props.setErrors(true);
        }

        if (atleastOneEmpty) {
            return this.props.setErrors(true);
        }

        if(hasErrors.every(err => Object.keys(companyValues).includes(err.name))) {
            this.props.setErrors(false);
        }
    }

    getUpdatedValue(name) {
        return this.state.companyValues.hasOwnProperty(name) ?  this.state.companyValues[name] : '';
    }

    fetchType(type, value, name) {
        const profile = {...this.state.company.company_profile.profile};

        if (name == 'company_type') {
            return <CompanyTypes values={this.state.companyValues} company_types={ this.getUpdatedValue('company_type') || profile.company_type }
                handleChange={e => this.onChangeObject(e)}
                onCheckboxTypeChange={(e) => this.onChangeObject({
                    company_type: e.option,
                    company_number: '',
                    company_number_type: e.type,
                })}/>
        }

        if (name === 'number_of_employees_range') {
            return <Dropdown
                placeholder='Please select number of employees'
                items={[
                    { label: '1-10', value: '1-10' },
                    { label: '11-50', value: '11-50' },
                    { label: '51-150', value: '51-150' },
                    { label: '151-250', value: '151-250' },
                    { label: '251+', value: '251+' }
                ]}
                value={this.getUpdatedValue('number_of_employees_range')}
                onChange={value => {
                    this.onChange({ target: {
                        name: 'number_of_employees_range',
                        value: value.value
                    } });
                }}/>
        }

        if (name === 'industry_name') {

            const ind  = this.state.industries.find(industry => {
                return industry.id === this.state.company.company_industry_id;
            });

            return <Dropdown label="Select your industry" value={ind ? {
                label : ind?.name,
                value : ind?.id
            } : null} items={this.state.industries.map(val => ({
                label: val.name,
                value: val.id,
            }))} onChange={ value => {
                this.setState({
                    company : Object.assign({}, this.state.company, { company_industry_id : value.value}),
                    companyValues : Object.assign({}, this.state.companyValues, {
                            industry_name : value.label,
                     })
                }, () => this.updateHasErrors());

            }}/>
        }

        let valid = this.individualValidation.hasOwnProperty(name) ? this.individualValidation[name](this.getUpdatedValue(name)) : true;

        if (name === 'email' || name === 'tel_no') {
            return <Input value={this.getUpdatedValue(name)} valid={valid} name={name} placeholder={type} onChange={this.onChange.bind(this)}/>
        }

        return <Input value={this.getUpdatedValue(name)} name={name} placeholder={type} onChange={this.onChange.bind(this)}/>
    }

    fetchTypes(filter) {
        const types = typeof filter === 'function' ? this.state.types.filter(filter) : this.state.types;

        return types.map(({type, value, name = ''}, index) => {
            const profile = { ...this.state.company.company_profile.profile };

            const hasError = this.state.hasErrors.find(d => d.name === name);

            const numberError = this.state.hasErrors.find(d => d.name == 'company_number');
            const companyError = this.state.hasErrors.find(d => d.name == 'company_type');

            if (numberError && name == 'company_type') {
                return <ApplicationSection key={index} title={type} description={ this.fetchType(type, value, name) }/>
            }

            if ((numberError || companyError) && name == 'company_number') {
                return;
            }

            if (!filteredCompanyTypes.includes(profile.company_type) && name == 'company_number') {
                return;
            }

            if (!hasError) return <ApplicationSection key={index} title={type} description={value}/>

            return (
                <ApplicationSection key={index} title={type} description={ this.fetchType(type, value, name) }/>
            )

        })
    }

    render() {
        if (this.state.company == null) return '';

        return (
            <div className="access-page">
                <div className="access-company__grid">
                    { this.fetchTypes(({ name }) => name !== 'address_one' && name !== 'address_two' && name !== 'address_city' && name !== 'address_post_code') }
                </div>

                <div className="access-company__grid">
                    { this.fetchTypes(({ name }) => name == 'address_one' || name == 'address_two' || name == 'address_city' || name == 'address_post_code') }
                </div>

                <p className="access-company__problem">Something not looking quite right? Head back to ‘My Account’ and
                    check your details.</p>
            </div>
        )
    }
}
